import * as React from "react"

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog"

/**
 * A dialog whose body is a real <form>, so Enter submits.
 *
 * Almost every dialog in this app was built as a plain <div> with a footer
 * Button carrying onClick, which means Enter does nothing and the only way to
 * save is to Tab past every field. Wrapping the body restores the behaviour
 * users expect from a form.
 *
 * Pass the primary action as `type="submit"` inside `footer`; `onSubmit` runs
 * on Enter and on click alike.
 */
const FormDialog = React.forwardRef((
  { open, onOpenChange, title, description, onSubmit, footer, children, className, ...props },
  ref
) => {
  const handleSubmit = (event) => {
    event.preventDefault()
    onSubmit?.(event)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent ref={ref} className={className} {...props}>
        <DialogHeader>
          {title && <DialogTitle>{title}</DialogTitle>}
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <form onSubmit={handleSubmit} className="contents">
          {children}
          {footer && <DialogFooter>{footer}</DialogFooter>}
        </form>
      </DialogContent>
    </Dialog>
  );
})
FormDialog.displayName = "FormDialog"

export { FormDialog }
